export const loaderTypes = {
	BUTTON_LOADER: 'buttonLoader',
	SPINNER_LOADER: 'spinnerLoader',
	TWIN_LOADER: 'twinLoader'
};
